import toast from 'react-hot-toast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'

import { Button } from 'components/atoms/button'
import { useStore } from 'hooks/useStore'
import { useRefreshInstagramConnectionMutation } from 'graphql/generated/scheme'
import { trueErrorMessage } from 'utils/error'

export interface InstagramSyncButtonProps {
	className?: string
}

export function InstagramSyncButton({ className }: InstagramSyncButtonProps) {
	const { refetchUser } = useStore()
	const [refreshInstagramConnection, { loading: syncing }] = useRefreshInstagramConnectionMutation({
		onCompleted: data => {
			if (data?.user?.refreshInstagramConnection) {
				toast.success('Instagram profile synced')
				refetchUser()
			} else {
				toast.error('No Instagram account connected')
			}
		},
		onError: error => {
			toast.error(trueErrorMessage(error))
		},
	})

	return (
		<Button
			variant="secondary"
			// An icon on phones: beside Disconnect, the label would squeeze the account name to a stub.
			className={clsx(className, '[@media(max-width:639px)]:!w-11 [@media(max-width:639px)]:!px-0')}
			title="Refresh your Instagram name and photo"
			onClick={() => refreshInstagramConnection()}
			disabled={syncing}
		>
			<FontAwesomeIcon
				icon={['fas', syncing ? 'spinner' : 'rotate']}
				spin={syncing}
				className={clsx(!syncing && 'sm:hidden', syncing && 'sm:mr-1')}
			/>
			<span className="sr-only sm:not-sr-only">Sync</span>
		</Button>
	)
}
